<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="skuQueryForm" :model="skuQueryForm" label-width="80px">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="skuQueryForm.categoryId"
                placeholder="请选择"
                @change="
                  getSelectOptions(
                    'phoneBrand',
                    'brandOptions',
                    skuQueryForm.categoryId
                  )
                "
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="skuQueryForm.brandId"
                placeholder="请选择"
                @change="skuTree"
              >
                <el-option
                  v-for="item in brandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="机型">
              <el-select
                clearable
                v-model="skuQueryForm.modelId"
                placeholder="请选择机型"
                filterable
              >
                <el-option
                  v-for="item in skuInfo.phoneModel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="小型号">
              <el-select
                clearable
                v-model="skuQueryForm.smallId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuSmallModel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="处理器">
              <el-select
                clearable
                v-model="skuQueryForm.cpuId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuCpu"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="显卡">
              <el-select
                clearable
                v-model="skuQueryForm.graphicsId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuGraphicsCard"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="固态硬盘">
              <el-select
                clearable
                v-model="skuQueryForm.solidId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuSolidDrive"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="机械硬盘">
              <el-select
                clearable
                v-model="skuQueryForm.mechanicalId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuMechanicalDrive"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="内存">
              <el-select
                clearable
                v-model="skuQueryForm.memoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuMemory"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="购买渠道">
              <el-select
                clearable
                v-model="skuQueryForm.channelId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuPurchaseChannel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="机身颜色">
              <el-select
                clearable
                v-model="skuQueryForm.colorId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuBodyColor"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="保修时长">
              <el-select
                clearable
                v-model="skuQueryForm.durationId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuWarrantyDuration"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col>
              <el-button type="primary" @click="getSkuList">查询</el-button>
              <el-button type="primary" @click="addSku">添加</el-button>
              <el-button type="primary" style="margin-left:6px" @click="exportExcelData">批量导出</el-button>
                <el-upload
                        style="display:inline"
                        action="aa"
                        :show-file-list="false"
                        :before-upload="importSendInfo">
                  <el-button style="margin-left:10px" type="primary" v-loading="fullscreenLoading">批量导入</el-button>
                </el-upload>
                 <a type="primary" style="margin-left:6px" @click="getSkuTemplete">导入模板下载</a>
            </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="value" label="编号"> </el-table-column>
        <el-table-column prop="name" label="SKU名称"> </el-table-column>
        <el-table-column prop="modelName" label="机型"> </el-table-column>
        <el-table-column prop="brandName" label="品牌"> </el-table-column>
        <el-table-column prop="categoryName" label="分类"> </el-table-column>
        <el-table-column prop="memoryName" label="内存"> </el-table-column>
        <el-table-column prop="channelName" label="购买渠道"> </el-table-column>
        <el-table-column prop="networkName" label="网络制式"> </el-table-column>
        <el-table-column prop="colorName" label="机身颜色"> </el-table-column>
        <el-table-column prop="smallName" label="小型号"></el-table-column>
        <el-table-column prop="durationName" label="保修时长"></el-table-column>
        <el-table-column prop="cpuName" label="处理器"></el-table-column>
        <el-table-column prop="graphicsName" label="显卡"></el-table-column>
        <el-table-column prop="solidName" label="固态硬盘"></el-table-column>
        <el-table-column prop="mechanicalName" label="机械硬盘"></el-table-column>
        <el-table-column prop="chargingInterfaceName" label="充电接口"></el-table-column>
        <el-table-column prop="chargingMethodName" label="充电方式"></el-table-column>
        <el-table-column prop="caseSizeName" label="表壳尺寸"></el-table-column>
        <el-table-column prop="caseMaterialName" label="表壳材质"></el-table-column>
        <el-table-column prop="watchStrapName" label="表带"></el-table-column>
        <el-table-column prop="strapColorName" label="表带颜色"></el-table-column>
        <el-table-column prop="leftRightEarName" label="左右耳"></el-table-column>
        <el-table-column prop="externalKeyboardName" label="外置键盘"></el-table-column>
        <el-table-column prop="accessoriesSituationName" label="配置情况"></el-table-column>
        <!-- <el-table-column prop="createTime" label="创建时间"> </el-table-column> -->
        <el-table-column prop="status" label="前端展示">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">展示</span>
            <span v-else>不展示</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editorSku(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >展示</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不展示</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index - 1)"
              type="text"
              size="small"
              v-if="scope.$index > 0"
              >上移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, scope.$index + 1)"
              type="text"
              size="small"
              v-if="scope.$index < tableData.length - 1"
              >下移</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, 0, true)"
              type="text"
              size="small"
              >置顶</el-button
            >
            <el-button
              @click="upDownMove(scope.row.id, -1, true)"
              type="text"
              size="small"
              >置底</el-button
            >
            <el-button @click="deleteSku(scope.row.id)" type="text" size="small" style="color: red;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="dlgType === 'change' ? '编辑SKU' : '新建SKU'"
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editSkuForm"
            :model="editSkuForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editSkuForm.value"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="SKU名称" prop="name">
              <el-input
                clearable
                v-model="editSkuForm.name"
              ></el-input>
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select
                clearable
                v-model="editSkuForm.categoryId"
                placeholder="请选择"
                @change="
                  dlgChangeCategory(
                    'phoneBrand',
                    'dlgBrandOptions',
                    editSkuForm.categoryId
                  )
                "
              >
                <el-option
                  v-for="item in categoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌" prop="brandId">
              <el-select
                clearable
                v-model="editSkuForm.brandId"
                placeholder="请选择"
                @change="skuTree"
              >
                <el-option
                  v-for="item in dlgBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机型" prop="modelId">
              <el-select
                clearable
                v-model="editSkuForm.modelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in skuInfo.phoneModel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="内存" prop="memoryId">
              <el-select
                clearable
                v-model="editSkuForm.memoryId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuMemory"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="购买渠道" prop="channelId">
              <el-select
                clearable
                v-model="editSkuForm.channelId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuPurchaseChannel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="机身颜色" prop="colorId" v-if="editSkuForm.categoryId==6099">
              <el-select
                clearable
                v-model="editSkuForm.colorId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuBodyColor"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="小型号" prop="smallId" v-if="editSkuForm.categoryId==6099">
              <el-select
                clearable
                v-model="editSkuForm.smallId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuSmallModel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="保修时长" prop="durationId">
              <el-select
                clearable
                v-model="editSkuForm.durationId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuWarrantyDuration"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="网络制式" prop="networkId" v-if="editSkuForm.categoryId==10649 || editSkuForm.categoryId==6099||editSkuForm.categoryId==10391">
              <el-select
                clearable
                v-model="editSkuForm.networkId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuNetwork"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="处理器" prop="cpuId">
              <el-select
                clearable
                v-model="editSkuForm.cpuId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuCpu"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="显卡" prop="graphicsId">
              <el-select
                clearable
                v-model="editSkuForm.graphicsId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuGraphicsCard"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="固态硬盘" prop="solidId">
              <el-select
                clearable
                v-model="editSkuForm.solidId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuSolidDrive"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="机械硬盘" prop="mechanicalId">
              <el-select
                clearable
                v-model="editSkuForm.mechanicalId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuMechanicalDrive"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="充电接口" prop="chargingInterfaceId" v-if="editSkuForm.categoryId==10649" >
              <el-select
                clearable
                v-model="editSkuForm.chargingInterfaceId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuChargingInterface"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="充电方式" prop="chargingMethodId">
              <el-select
                clearable
                v-model="editSkuForm.chargingMethodId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuChargingMethod"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="表壳尺寸" prop="caseSizeId" v-if="editSkuForm.categoryId==10649">
              <el-select
                clearable
                v-model="editSkuForm.caseSizeId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuCaseSize"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="表壳材质" prop="caseMaterialId" v-if="editSkuForm.categoryId==10649">
              <el-select
                clearable
                v-model="editSkuForm.caseMaterialId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuCaseMaterial"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="表带" prop="watchStrapId" v-if="editSkuForm.categoryId==10649">
              <el-select
                clearable
                v-model="editSkuForm.watchStrapId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuWatchStrap"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="表带颜色" prop="strapColorId" v-if="editSkuForm.categoryId==10649">
              <el-select
                clearable
                v-model="editSkuForm.strapColorId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuStrapColor"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="左右耳" prop="leftRightEarId" v-if="editSkuForm.categoryId==14908">
              <el-select
                clearable
                v-model="editSkuForm.leftRightEarId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuLeftRightEar"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="外置键盘" prop="externalKeyboardId">
              <el-select
                clearable
                v-model="editSkuForm.externalKeyboardId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuExternalKeyboard"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="配置情况" prop="accessoriesSituationId">
              <el-select
                clearable
                v-model="editSkuForm.accessoriesSituationId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in skuInfo.skuAccessoriesSituation"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditorSkuDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      skuQueryForm: {
        categoryId: null,
        brandId: null,
        channelId: null,
        colorId: null,
        durationId: null,
        memoryId: null,
        modelId: null,
        networkId: null,
        smallId: null,
        cpuId: null,
        graphicsId: null,
        solidId: null,
        mechanicalId: null,
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      fullscreenLoading:false,

      // 新建编辑对话框数据

      isDlg: false,
      editSkuForm: {
        id: null,
        name: null,
        brandId: null,
        categoryId: null,
        channelId: null,
        colorId: null,
        durationId: null,
        memoryId: null,
        modelId: null,
        networkId: null,
        smallId: null,
        cpuId: null,
        graphicsId: null,
        solidId: null,
        mechanicalId: null,
        status: 0,
      },

      editorFormRules: {
        name: [{ required: true, message: "请输入SKU名称", trigger: "change" }],
        modelId: [{ required: true, message: "请输入机型", trigger: "change" }],
        brandId: [{ required: true, message: "请选择品牌", trigger: "change" }],
        categoryId: [
          { required: true, message: "请选择分类", trigger: "change" },
        ],
        // memoryId: [
        //   { required: true, message: "请选择内存", trigger: "change" },
        // ],
        // channelId: [
        //   { required: true, message: "请选择购买渠道", trigger: "change" },
        // ],
        // colorId: [
        //   { required: true, message: "请选择机身颜色", trigger: "change" },
        // ],
        // smallId: [
        //   { required: true, message: "请选择小型号", trigger: "change" },
        // ],
        // durationId: [
        //   { required: true, message: "请选择保修时长", trigger: "change" },
        // ],
        // networkId: [
        //   { required: true, message: "请选择网络制式", trigger: "change" },
        // ],
      },

      dlgType: "change",

      // 选择
      modelOptions: [],
      loading: false,

      categoryOptions: [],
      brandOptions: [],
      dlgBrandOptions: [],
      skuInfo: {},
    };
  },
  watch: {},
  computed: {},
  methods: {
      deleteSku(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteSku({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getSkuList()
          }
      })
      })
   
    },
      // click事件
    exportExcelData () {
      let self = this
      self.$api
        .listSearch({
          page: self.currentPage,
          size: self.tableTotal,
          categoryId: self.skuQueryForm.categoryId || null,
          brandId: self.skuQueryForm.brandId || null,
          channelId: self.skuQueryForm.channelId || null,
          colorId: self.skuQueryForm.colorId || null,
          durationId: self.skuQueryForm.durationId || null,
          memoryId: self.skuQueryForm.memoryId || null,
          modelId: self.skuQueryForm.modelId || null,
          networkId: self.skuQueryForm.networkId || null,
          smallId: self.skuQueryForm.smallId || null,
          cpuId: self.skuQueryForm.cpuId || null,
          graphicsId: self.skuQueryForm.graphicsId || null,
          solidId: self.skuQueryForm.solidId || null,
          mechanicalId: self.skuQueryForm.mechanicalId || null,
        })
        .then((res) => {
          var downLoadTableData = res.data.records || [];
          require.ensure([], () => {
                const { export_json_to_excel } = require("@/vender/Export2Excel");
                const fieldName = ["编号", "SKU名称","机型","品牌","分类","内存","购买渠道","网络制式","机身颜色","小型号","保修时长","处理器","显卡","固态硬盘","机械硬盘","充电接口","充电方式","表壳尺寸","表壳材质","表带","表带颜色",'状态'];
                const filterVal = ["value", "name", "modelName", "brandName", "categoryName", "memoryName", "channelName", "networkName", "colorName", "smallName", "durationName", "cpuName", "graphicsName", "solidName", "mechanicalName","chargingInterfaceName","chargingMethodName","caseSizeName","caseMaterialName","watchStrapName","strapColorName","status"];
                const data = downLoadTableData.map(v => filterVal.map(j => {
                              if(j=="status"){
                                return v[j]==1?"展示":"不展示"
                              }else{
                                return v[j]
                              } 
                      } 
                ));
                export_json_to_excel(fieldName, data, "SKU列表"+self.$moment(new Date()).format("YYYYMMDDHH:mm:ss"));
              });
        });
    },
     // 批量导入
    importSendInfo(file) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', file)
      this.$api.imporHjxSkuTemplete(formData).then(res => {
        this.fullscreenLoading  = false
        if(res.code === 200) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
          this.getSkuList()
        }
      })
      return false;
    },
    getSkuTemplete(){
      window.open(`/api/hjx/sku/getHjxSkuTemplete`,"_blank")
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getSkuList();
    },

    //获取品牌下的sku信息
    skuTree(val) {
      let self = this;
      self.$api
        .skuTree({
          brandId: val,
        })
        .then((res) => {
          self.skuInfo = res.data;
        });
    },

    // 获取表格数据
    getSkuList() {
      let self = this;
      self.$api
        .listSearch({
          page: self.currentPage,
          size: self.pageSize,
          categoryId: self.skuQueryForm.categoryId || null,
          brandId: self.skuQueryForm.brandId || null,
          channelId: self.skuQueryForm.channelId || null,
          colorId: self.skuQueryForm.colorId || null,
          durationId: self.skuQueryForm.durationId || null,
          memoryId: self.skuQueryForm.memoryId || null,
          modelId: self.skuQueryForm.modelId || null,
          networkId: self.skuQueryForm.networkId || null,
          smallId: self.skuQueryForm.smallId || null,
          cpuId: self.skuQueryForm.cpuId || null,
          graphicsId: self.skuQueryForm.graphicsId || null,
          solidId: self.skuQueryForm.solidId || null,
          mechanicalId: self.skuQueryForm.mechanicalId || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addSku() {
      this.dlgType = "new";
      this.editSkuForm=this.$options.data().editSkuForm;
      this.$nextTick(()=>{
          this.$refs['editSkuForm'].clearValidate()
      })
      this.isDlg = true;
    },

    // 修改
    editorSku(row) {
      let self = this;
      self.dlgType = "change";
      self.editSkuForm = row;

      self.getSelectOptions(
        "phoneBrand",
        "dlgBrandOptions",
        self.editSkuForm.categoryId
      );
      self.skuTree(self.editSkuForm.brandId);
      self.isDlg = true;
    },

    dlgChangeCategory(typeKey, optionName, categoryId) {
      this.getSelectOptions(typeKey, optionName, categoryId);
      this.editSkuForm.parentId = null;
    },

    // 关闭编辑对话框
    closeEditorSkuDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editSkuForm"].validate((valid) => {
        if (valid) {
          let params = {};
          for (let i in self.editSkuForm) {
            params[i] = this.editSkuForm[i];
          }
          self.$api.updateSKu(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getSkuList();
              self.closeEditorSkuDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 请求分类列表，提供编辑时选择用
    getSelectOptions(typeKey, optionName, categoryId) {
      let self = this;
      self.$api
        .getClass({
          categoryId: categoryId,
          typeKey: typeKey,
          status: 1,
          page: 1,
          size: 100000,
        })
        .then((res) => {
          if (res.code === 200) {
            self[optionName] = res.data.records;
          }
        });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      this.$api.updateSKu(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getSkuList();
        }
      });
    },
    upDownMove(id, toIndex, type) {
      let self = this;
      this.$api
        .swap({
          currentId: id,
          swapId: type ? toIndex : self.tableData[toIndex].id,
        })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "移动成功",
              type: "success",
            });
            self.getSkuList();
          }
        });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getSkuList();
    self.getSelectOptions("category", "categoryOptions");
  },
};
</script>
<style lang="less" scoped></style>
